import React from 'react';
import {
  JsonFormsCellRendererRegistryEntry,
  JsonFormsRendererRegistryEntry,
  JsonSchema,
  UISchemaElement,
} from '@jsonforms/core';
import { Col, Row } from 'antd';
import { JsonFormsDispatch } from '@jsonforms/react';

interface RenderLayoutElementsProps {
  elements: UISchemaElement[];
  schema: JsonSchema;
  path: string;
  enabled: boolean;
  direction: 'row' | 'column';
  renderers?: JsonFormsRendererRegistryEntry[];
  cells?: JsonFormsCellRendererRegistryEntry[];
}

export const RenderLayoutElements: React.FC<RenderLayoutElementsProps> = ({
  elements,
  schema,
  path,
  enabled,
  direction,
  renderers,
  cells,
}: RenderLayoutElementsProps) => {
  const GridChild = direction === 'row' ? Col : Row;
  const containerProps: React.HTMLAttributes<HTMLDivElement> &
    React.CSSProperties = {};
  if (direction === 'row') {
    containerProps.flex = 1;
  } else {
    containerProps.style = { display: 'flex', flexDirection: 'row' };
  }

  return (
    <>
      {elements.map((child, index) => (
        <GridChild
          {...containerProps}
          key={`${path}-${index}`}
        >
          <JsonFormsDispatch
            uischema={child}
            schema={schema}
            path={path}
            enabled={enabled}
            renderers={renderers}
            cells={cells}
          />
        </GridChild>
      ))}
    </>
  );
};
